// import libs
import debounce from 'lodash/debounce';
import { sendMessage, DOMReady } from './utils';
import responseData from './data.csv';
import 'whatwg-fetch';

// import base styles'
import './app.scss';

// enable hot module replacement
if ( module.hot ) {
	module.hot.accept();
}

DOMReady( () => {
	const table = document.querySelector( '.l-interactive__table' );

	responseData.forEach( ( d ) => d.response = 'Did not respond.' === d.response ? null : d.response );

	const rows = responseData.sort( ( a, b ) => ( ! b.response ? - 1 : 1 ) ).map( ({
		operator, licence_type, operator_type, status, response,
	}) => {
		const row = document.createElement( 'details' );
		row.classList.add( 'c-table__row' );
		if ( null === response ) row.classList.add( 'c-table__row--noResponse' );

		const summary = document.createElement( 'summary' );
		summary.classList.add( 'c-table__summary' );

		summary.innerHTML = `<div class="c-table__summaryContent">
			<h3 class='c-table__heading'>${operator}</h3>
			<p class='c-table__subheading'>
				<span>License type: <strong>${licence_type}</strong></span>
				<span>Operator type: <strong>${operator_type}</strong></span>
				<span>Status: <strong>${status}</strong></span>
			</p>
			${null === response ? '<div class="c-table__details"><p><em>Did not respond.</em></p></div>' : ''}
		</div>`;

		row.appendChild( summary );

		if ( null !== response ) {
			const details = document.createElement( 'div' );
			details.classList = 'c-table__details';
			details.innerHTML = response.split( '\n\n' ).map( ( paragraph ) => `<p>${paragraph}</p>` ).join( '' );

			row.appendChild( details );
		}

		table.appendChild( row );

		return row;
	});

	rows.forEach( ( row ) => {
		row.addEventListener( 'click', () => {
			rows.filter( ( r ) => r.open && r !== row ).forEach( ( r ) => r.open = false );
		});
	});

	// Resize after content loaded
	sendMessage({
		height: document.documentElement.offsetHeight,
		action: 'setHeight',
	});

	// bind event to capture resize and orientation change
	const resizeHandler = debounce( () => {
		sendMessage({
			height: document.documentElement.offsetHeight,
			action: 'setHeight',
		});
	}, 200 );
	window.addEventListener( 'orientationchange', resizeHandler );
	window.addEventListener( 'resize', resizeHandler );
});
